import { mapGetters } from 'vuex';
import templateBuilder from '@/helpers/templateBuilder';

export default {
  name: 'ProductMapList',
  data() {
    return {
      className: 'app__product__map-list',
    };
  },
  computed: {
    listClassName() {
      return `${this.className}`;
    },
    itemClassName() {
      return `${this.className}__item`;
    },
    imageClassName() {
      return `${this.className}__image`;
    },
    mapClassName() {
      return `${this.className}__map`;
    },
    linkListClassName() {
      return `${this.className}__map__list`;
    },
    contentClassName() {
      return `${this.className}__content`;
    },
    noResultsClassName() {
      return `${this.className}__no__results`;
    },
    showNoResultsMessage() {
      return this.showNoResults && !this.products.length;
    },
    ...mapGetters({
      seoUrl: 'getSeoUrl',
      mapFormatNames: 'getMapFormatNames',
    }),
  },
  methods: {
    buildLink(option) {
      return templateBuilder(this.seoUrl, { seoUrl: option.seoUrl });
    },
    getMapTypeName(type) {
      return this.mapFormatNames[type] || type;
    },
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    showNoResults: {
      type: Boolean,
      default: false,
    },
    noResultsMessage: {
      type: String,
      default: '',
    },
  },
};
